import React from 'react';
export var SuccessStatusIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
    React.createElement("circle", { fill: "#54b948", cx: "8", cy: "8", r: "7" }),
    React.createElement("path", { fill: "#fff", d: "M7.006,11.409a1,1,0,0,1-.707-.293L3,7.831,4.417,6.417,7,9,11.591,4.41l1.414,1.414L7.713,11.116A1,1,0,0,1,7.006,11.409Z" }))); };
//# sourceMappingURL=SuccessStatusIcon.js.map